var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-preview-view"},[_c('div',{staticClass:"preview-image-group"},_vm._l((_vm.preview),function(item,index){return _c('div',{key:index,staticClass:"preview-image"},[_c('van-image',{attrs:{"width":"100%","src":item}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }